import SelectionInput, { SelectionInputProps } from './SelectionInput';

export type { SelectionInputProps };
export default SelectionInput;
